export default __webpack_public_path__ + "static/media/photo--sm--kara7.42c0c8f1.jpg";